
import { io } from 'socket.io-client';

// const socket = io('http://localhost:3001'); // update with your API URL
// const socket = io('http://localhost:3001', {
//   autoConnect: false // <- Don't connect until explicitly told
// });

const socket = io(process.env.REACT_APP_SOCKET_SERVER, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});
// Log the URL being used
console.log("🟢 Attempting to connect to Socket.IO server:", process.env.REACT_APP_SOCKET_SERVER);
// socket.on('connect', () => {
//   console.log('Connected:', socket.id);
//   socket.emit('registerAgent', '9228159028'); // your agent phone number
// });

// socket.on('incomingCall', (data) => {
//   console.log('Incoming call from:', data.caller);
// });

socket.on("connect", () => {
  console.log("✅ Connected to", process.env.REACT_APP_SOCKET_SERVER, "with id:", socket.id);
});

// Listen for connection error
socket.on("connect_error", (err) => {
  console.error("❌ Connection failed to", process.env.REACT_APP_SOCKET_SERVER, err.message);
});

// Listen for disconnection
socket.on("disconnect", (reason) => {
  console.warn("⚠️ Disconnected from", process.env.REACT_APP_SOCKET_SERVER, "Reason:", reason);
});

socket.on("reconnect_attempt", (attempt) => {
  console.log(`♻️ Reconnection attempt #${attempt} to ${process.env.REACT_APP_SOCKET_SERVER}`);
});

socket.on("reconnect_failed", () => {
  console.error("🚫 Failed to reconnect after max attempts.");
});

socket.on("error", (err) => {
  console.error("🚨 Socket error:", err);
});

// Debug ALL incoming events
socket.onAny((event, ...args) => {
  console.log(`📥 Received event: "${event}"`, args);
});

// Wrap emit to debug ALL outgoing events
const originalEmit = socket.emit;
socket.emit = function (event, ...args) {
  console.log(`📤 Emitting event: "${event}"`, args);
  return originalEmit.apply(socket, [event, ...args]);
};

export default socket;